// Generated by ReScript, PLEASE EDIT WITH CARE


function shouldDisplayPremiumLotBanner(authToken, isPremiumLot) {
  if (typeof authToken !== "object") {
    return false;
  }
  var variant = authToken.NAME;
  if ((variant === "Authenticated" || variant === "AuthenticatedForPreview") && isPremiumLot) {
    return true;
  } else {
    return false;
  }
}

function tokenValue(me) {
  var match = me.authToken;
  if (typeof match !== "object") {
    return ;
  }
  var variant = match.NAME;
  if (variant === "Authenticated" || variant === "AuthenticatedForPreview") {
    return match.VAL.value;
  }
  
}

export {
  shouldDisplayPremiumLotBanner ,
  tokenValue ,
}
/* No side effect */
